var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-detail-container" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("h2", [_vm._v("优惠券详情")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goBack } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.couponData
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "info-card" }, [
                    _c("div", { staticClass: "basic-info-section" }, [
                      _c("h3", [_vm._v("基本信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "coupon-info" }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [_vm._v("ID:")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.couponData.typeId)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("名称:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.couponData.typeName)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("类型:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getCouponTypeText(_vm.couponData.typeGroup)
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("金额:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(_vm.formatAmount(_vm.couponData.typeMoney))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("发放数量:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.couponData.grossNum || 0)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("使用数量:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.couponData.useNum || 0)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("是否分享:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "value" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      _vm.couponData.canShare === 1
                                        ? "success"
                                        : "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.couponData.canShare === 1
                                          ? "是"
                                          : "否"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("第三方ID:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(_vm.couponData.thirdCouponId || "无")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("添加时间:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(_vm.couponData.addTime))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("图片:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "value" },
                            [
                              _vm.couponData.imgUrl
                                ? _c("el-image", {
                                    staticClass: "coupon-image",
                                    attrs: {
                                      src: _vm.getImageUrl(
                                        _vm.couponData.imgUrl
                                      ),
                                      fit: "cover",
                                      "preview-src-list": [
                                        _vm.getImageUrl(_vm.couponData.imgUrl),
                                      ],
                                    },
                                  })
                                : _c("span", [_vm._v("无图片")]),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("券说明:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "value" },
                            [
                              _c("el-input", {
                                staticClass: "description-textarea",
                                attrs: {
                                  type: "textarea",
                                  value: _vm.couponData.typeDesc || "无",
                                  rows: 4,
                                  readonly: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("公众号:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "value" },
                            [
                              _vm.parsedMpIds && _vm.parsedMpIds.length > 0
                                ? _c(
                                    "el-table",
                                    {
                                      staticClass: "mp-table",
                                      attrs: {
                                        data: _vm.parsedMpIds,
                                        border: "",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "name",
                                          label: "公众号名称",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "id",
                                          label: "公众号ID",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [_vm._v("无")]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "info-card" }, [
                    _c("div", { staticClass: "store-info-section" }, [
                      _c("h3", [_vm._v("适用门店")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "store-tree-container" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "store-card",
                              attrs: { shadow: "never" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "el-icon-office-building",
                                    }),
                                    _vm._v(
                                      "\n                  门店列表\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "card-content" }, [
                                _c(
                                  "div",
                                  { staticClass: "store-tree" },
                                  [
                                    _c("el-tree", {
                                      ref: "shopTree",
                                      attrs: {
                                        data: _vm.shopTreeData,
                                        props: _vm.shopTreeProps,
                                        "default-expanded-keys":
                                          _vm.expandedKeys,
                                        "default-checked-keys": _vm.checkedKeys,
                                        "node-key": "nodeKey",
                                        "show-checkbox": "",
                                        disabled: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "loading-container" },
            [_c("el-empty", { attrs: { description: "暂无数据" } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }